import ToolbarDivider from '~/components/toolbar/shared/ToolbarDivider';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import DvhTool from '~/components/toolbar/tools/DvhTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';

export default function DoseTools() {
    return (
        <>
            <PanTool />
            <BoxZoomTool />
            <ResetViewTool />
            <ToolbarDivider />
            <DvhTool />
        </>
    );
}
